import {GET_USER_INFO} from '../../constants/UserConstants';
import {ActionWithoutPayload} from "../../@types/actions";

export const GetUserInfoAction = (): ActionWithoutPayload<any> => ({type: GET_USER_INFO});
